import { Account } from "@/types/auth";
import { Workspace } from "@/types/workspace";

export const getWorkspaceImg = (workspace: Partial<Workspace>) => {
  if (workspace.avatar) {
    return workspace.avatar;
  }
  return `https://avatar.vercel.sh/workspace_${workspace.slug}_boudraw.svg`;
};

export const getUserImg = (account: Partial<Account>) => {
  if (account.avatar) {
    return account.avatar;
  }

  return `https://avatar.vercel.sh/user_${account.id}_boudraw.svg`;
};
